class UFilteredListSortSelector extends Uneet {
  constructor (domElement, sortChangeCallback) {
    super(domElement)
    this.isAscending = true
    this.sortChangeCallback = this.__debounce(sortChangeCallback, 100)
    this.__init()
  }

  __init () {
    // init the isAscending class
    this._e.toggleClass('isAscending', this.isAscending)

    // bind the toggle button
    const btn = this._e.querySelectorAll('button')[0]
    btn.onClick((ev) => {
      this.toggleSort()
    })
  }

  toggleSort (forceAsc = null) {
    if (forceAsc === null) {
      this.isAscending = !this.isAscending
    } else {
      this.isAscending = forceAsc
    }

    this._e.toggleClass('isAscending', this.isAscending)

    this.sortChangeCallback(this.isAscending)
  }

  getSort () {
    return (this.isAscending) ? 'asc' : 'desc'
  }
}
